import React, { useEffect, useRef, useState } from 'react';

import { useCartStore } from 'src/hooks/cart';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const SystemAlerts = () => {
    const alertRef = useRef(null)
    const [notificationData, setNotificationData] = useState([])
    const [{ latest_system_notification_data }, { }, { }] = useDOMAttachToSystemStore();
    const [{ CART_DATA, CART_PRODUCT_DATA }, { }, { }] = useCartStore();

    useEffect(() => {
        validateCartEOLObsoleteExist()
        if (latest_system_notification_data.type === 'clear') {
            setNotificationData([]);
            return;
        }
        if (alertRef !== undefined && alertRef !== null && alertRef.current !== undefined &&
            alertRef.current !== null && latest_system_notification_data.content !== undefined &&
            latest_system_notification_data.type !== 'clear') {
            let d = true;
            if (latest_system_notification_data.do_not_auto_focus !== undefined && latest_system_notification_data.do_not_auto_focus === true) {
                d = false;
            }
            if (d === true) {
                alertRef.current.scrollIntoView()
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }
        }

        if (latest_system_notification_data.content !== undefined && latest_system_notification_data.type !== 'clear') {
            setNotificationData((prevData) => {
                let f = {};
                let aH = [...prevData, latest_system_notification_data];
                aH.map((v, i) => {
                    f[v.content] = v;
                });
                let f_h = [];
                Object.entries(f).map((v, i) => {
                    f_h.push({ id: i, ...v[1] })
                });
                return f_h;
            })
        }
    }, [latest_system_notification_data, CART_PRODUCT_DATA]);

    const validateCartEOLObsoleteExist = () => {
        let cartArr = [];
        if (CART_PRODUCT_DATA && CART_DATA && Array.isArray(CART_DATA) && CART_DATA.length > 0) {
            if (Object.entries(CART_PRODUCT_DATA).length > 0) {
                Object.entries(CART_DATA).forEach((x, y) => {
                    let s = {
                        isObsoleteFlag: CART_PRODUCT_DATA[x[1]['ERPPartNumber']] !== undefined ? CART_PRODUCT_DATA[x[1]['ERPPartNumber']].ObsoleteFlag : false,
                        isEOLFlag: CART_PRODUCT_DATA[x[1]['ERPPartNumber']] !== undefined ? CART_PRODUCT_DATA[x[1]['ERPPartNumber']].EndOfLifeOFlag : false
                    };
                    cartArr.push(s)
                });
            }
        }

        if (cartArr.length == 0) {
            const errMsg = "This cart contains EOL/Obsolete part."
            const notificationDataWithoutEolOrObsolete = notificationData.filter((item) => item.content != errMsg);
            setNotificationData(notificationDataWithoutEolOrObsolete);
        }
    }


    const removeAlert = (id) => {
        const notificationWithoutRemovedItem = notificationData.filter((notification) => notification.id != id);
        setNotificationData(notificationWithoutRemovedItem);
    }

    return (
        <>
            <div ref={alertRef} autoFocus={true} className="container">
                {notificationData.length > 0 &&
                    notificationData.map((v, i) => (
                        <div className="bs5 row" key={i}>
                            <div className="col-lg-12">
                                <div className={'alert alert-' + v.type} role="alert">
                                    <span><div dangerouslySetInnerHTML={{ __html: v.content }} /></span>
                                    <button type="button" className="close" data-dismiss={"alert" + i} aria-label="Close" onClick={() => removeAlert(v.id)}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </>
    )
};

export default SystemAlerts;
